import React from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".feedbackMessage-module_feedbackMessage__ocqJ2 {\n  --font-size: 0.9rem; }\n\n.ui.message {\n  font-size: var(--font-size) !important; }\n";
var styles = {"feedbackMessage":"feedbackMessage-module_feedbackMessage__ocqJ2"};
styleInject(css);

var MESSAGES = {
    de: {
        question: 'Haben Sie Anmerkungen oder einen Fehler entdeckt?',
        call: 'Wir freuen uns über Ihre Nachricht an'
    },
    fr: {
        question: 'Avez-vous des remarques ou avez-vous découvert une erreur?',
        call: 'Nous nous réjouissons de votre message à'
    }
};
function FeedbackMessage(props) {
    var t = function (key) {
        return (props[key] ||
            (MESSAGES[props.locale || 'de'].hasOwnProperty(key)
                ? MESSAGES[props.locale || 'de'][key]
                : 'TRANSLATED_STRING_NOT_FOUND: ' + key));
    };
    var _a = props.className, className = _a === void 0 ? '' : _a, _b = props.inverted, inverted = _b === void 0 ? false : _b, _c = props.mailTo, mailTo = _c === void 0 ? 'interaktiv@tamedia.ch' : _c, _d = props.project, project = _d === void 0 ? window.document.title : _d;
    var invertedClass = inverted ? 'inverted' : '';
    return (React.createElement("div", { className: "ui " + className + " " + invertedClass + " message feedback-message " + styles.feedbackMessage },
        React.createElement("div", { className: "ui " + invertedClass + " list" },
            React.createElement("div", { className: 'item' },
                React.createElement("i", { className: 'comments icon' }),
                React.createElement("div", { className: 'content' },
                    React.createElement("div", { className: 'header' }, t('question')),
                    t('call'),
                    ' ',
                    React.createElement("a", { href: "mailto:" + encodeURIComponent(mailTo) + "?subject=" + encodeURIComponent(project) }, mailTo.split(',').join(', ')),
                    ".")))));
}

export default FeedbackMessage;
export { FeedbackMessage };
//# sourceMappingURL=index.js.map
